import { html } from "lit";
var icon_refresh_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M28.188 16c.487 0 .812.488.812.813C28.512 23.637 22.825 29 16 29c-4.713 0-9.1-2.6-11.375-6.663v4.226c0 .487-.325.812-.813.812-.487 0-.812-.325-.812-.813v-6.5c0-.487.325-.812.813-.812h6.5c.487 0 .812.325.812.813 0 .487-.325.812-.813.812h-4.55c1.788 3.9 5.85 6.5 10.238 6.5 6.012 0 11.05-4.55 11.375-10.563 0-.487.325-.812.813-.812zM16 3c4.712 0 9.1 2.6 11.375 6.662V5.438c0-.487.325-.812.813-.812.487 0 .812.325.812.813v6.5c0 .487-.325.812-.813.812h-6.5c-.487 0-.812-.325-.812-.813 0-.487.325-.812.813-.812h4.55c-1.788-3.9-5.85-6.5-10.238-6.5-6.012 0-10.887 4.713-11.375 10.563 0 .487-.325.812-.813.812l-.109-.008c-.426-.066-.703-.505-.703-.805C3.487 8.364 9.175 3 16 3z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_refresh_default as default
};
//# sourceMappingURL=icon-refresh.js.map
